import styled from "styled-components";
import THEME from "theme";

import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Title } from "components/atoms/Typography";
import ModalButton, { useModalButtonContext } from "components/organisms/ModalButton";
import FormButton from "components/organisms/form/FormButton";
import { useStrombestillingApiMutation } from "hooks/useStrombestillingApi";

export function DeleteOrderOfferButton({ offerId }: { readonly offerId: string }) {
	return (
		<StyledModalButton
			style={{ fontSize: "20px" }}
			className="noStyle"
			title="Slett tilbud"
			icon={<FontAwesomeIcon color={THEME.colors.primary} icon={faTrashCan} />}
		>
			<ModalContent>
				<Title>Slett tilbud</Title>
				<p>Er du sikker? Kundens lenke vil slutte å fungere.</p>
				<SubmitButton orderId={offerId} />
				<CloseButton />
			</ModalContent>
		</StyledModalButton>
	);
}

function SubmitButton({ orderId }: { readonly orderId: string }) {
	const { close } = useModalButtonContext();
	const mutation = useStrombestillingApiMutation(`/orderoffer/${orderId}`, ["orderoffers"], "DELETE");

	return (
		<FormButton
			style={{ marginRight: "1rem" }}
			onClick={(e) => {
				mutation.mutate({});
				e.stopPropagation();
				close();
			}}
			label="Slett tilbud"
		/>
	);
}

function CloseButton() {
	const { close } = useModalButtonContext();

	return (
		<FormButton
			onClick={(e) => {
				close();
				e.stopPropagation();
			}}
			label="Avbryt"
		/>
	);
}

const StyledModalButton = styled(ModalButton)`
	padding: 0 0.5rem;
	border-radius: 1rem;
`;

const ModalContent = styled.div`
	padding: 1rem;
`;
